import React from 'react';
import { Card, Tab } from 'react-bootstrap';

import { TabsHistory } from '../../../app/components/TabsHistory';
import { OrdersSentTab } from '../../components/Orders/OrdersSentTab';
import { OrdersWaitingTab } from '../../components/Orders/OrdersWaitingTab';
import { OrdersCompletedTab } from '../../components/Orders/OrdersCompletedTab';
import { useTranslation } from '../../../common/hooks/useTranslation';

export enum ProjectOrdersTabs {
  SENT = 'sent',
  WAITING = 'waiting',
  COMPLETED = 'completed',
}

export const OrdersView: React.FC = () => {
  const { t, tk } = useTranslation('orderLng');
  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">{t(tk.order.orders)}</Card.Title>
        <TabsHistory
          activeKey={ProjectOrdersTabs.WAITING}
          id="product"
          className="mb-3"
          mountOnEnter
          unmountOnExit
        >
          <Tab
            eventKey={ProjectOrdersTabs.WAITING}
            title={t(tk.order.waiting)}
            className="m-3"
          >
            <OrdersWaitingTab />
          </Tab>
          <Tab
            eventKey={ProjectOrdersTabs.COMPLETED}
            title={t(tk.order.completed)}
            className="m-3"
          >
            <OrdersCompletedTab />
          </Tab>
          <Tab
            eventKey={ProjectOrdersTabs.SENT}
            title={t(tk.order.sent)}
            className="m-3"
          >
            <OrdersSentTab />
          </Tab>
        </TabsHistory>
      </Card.Body>
    </Card>
  );
};
